import { render, staticRenderFns } from "./impersonation.vue?vue&type=template&id=1a4b2bc8&"
import script from "./impersonation.vue?vue&type=script&lang=ts&"
export * from "./impersonation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports